module.exports = __webpack_public_path__ + "img/Birthday.21c089ee.png";